import React from 'react';
import JobDateTimeField, { JobDateTimeFieldProps } from 'components/JobDateTimeField';
import { utcToZonedTime } from 'date-fns-tz';
import { useRecordContext } from 'ra-core';

const isOvernight = ({ starts_time, ends_time, primary_location, location }) => {
  if (!starts_time || !ends_time) {
    return false;
  }
  const d = (t) => utcToZonedTime(t, (primary_location ?? location)?.timezone_lookup).getDate();
  return d(starts_time) - d(ends_time) !== 0;
};

export const JobTimeField = (props: JobDateTimeFieldProps) => {
  const record = useRecordContext(props);
  let format = props.format;
  if (format && props.source === 'ends_time' && record && isOvernight(record as any)) {
    format = `${format} '(overnight)'`;
  }
  return <JobDateTimeField {...props} format={format} />;
};
